<template>
  <div>
    <!-- 充值 -->
    <el-dialog
      title="充值"
      class="dialogbox"
      :visible.sync="dialogTableVisible"
      width="600px"
      @close="guanbi('loginFormRef2')"
    >
      <el-form :model="form2" ref="loginFormRef2" :rules="loginFormRules">
        <el-form-item label="充值对象：">
          <div>{{ name }}</div>
        </el-form-item>
        <el-form-item label="充值类型：" prop="style">
          <el-select v-model="form2.style" placeholder="请选择">
            <el-option label="授权" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产品类型：" prop="package_type">
          <el-select
            v-model="form2.package_type"
            placeholder="请选择"
            @change="setMeal"
          >
            <el-option
              v-if="
                this.package.other_num != undefined &&
                this.package.other_num.length > 0
              "
              label="呼叫中心"
              :value="7"
            ></el-option>
            <!-- <el-option-group label="通信产品">
              <el-option
                v-if="
                  this.package.black_num != undefined &&
                    this.package.black_num.length > 0
                "
                label="防骚扰"
                :value="1"
              ></el-option>
              <el-option
                v-if="
                  this.package.call_num != undefined &&
                    this.package.call_num.length > 0
                "
                label="语音"
                :value="2"
              ></el-option>
              <el-option
                v-if="
                  this.package.sms_num != undefined &&
                    this.package.sms_num.length > 0
                "
                label="文字短信"
                :value="3"
              ></el-option>
              <el-option
                v-if="
                  this.package.video_sms_num != undefined &&
                    this.package.video_sms_num.length > 0
                "
                label="视频短信"
                :value="4"
              ></el-option>
            </el-option-group>
            <el-option-group label="Saas产品">
              <el-option
                v-if="
                  this.package.other_num != undefined &&
                    this.package.other_num.length > 0
                "
                label="呼叫中心"
                :value="7"
              ></el-option>
            </el-option-group> -->
          </el-select>
        </el-form-item>
        <el-form-item label="套餐：" prop="package_id">
          <el-select
            v-model="form2.package_id"
            placeholder="请选择"
            @change="SysAction"
          >
            <el-option
              v-for="(item, index) in this.packageList"
              :key="index"
              :label="item.package_name + '(' + item.number + ')'"
              :value="item.package_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="余数：">
          <div>{{ this.count }}</div>
        </el-form-item>
        <el-form-item
          label="充值个数："
          prop="charge"
          :rules="[{ required: true, validator: minRules, trigger: 'blur' }]"
        >
          <el-input
            v-model="form2.charge"
            autocomplete="off"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="form2.remark" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item
          style="width: 95%; display: flex; justify-content: flex-end"
        >
          <el-button size="small" @click="dialogTableVisible = false"
            >取 消</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="addRecharge('loginFormRef2')"
            >确 定</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 充值 -->

    <!-- 扣款 -->
    <el-dialog
      title="扣款"
      class="dialogbox"
      :visible.sync="dialogTableVisiblekou"
      width="600px"
      @close="guanbi('loginFormRef20')"
    >
      <el-form
        :model="form20"
        label-position="right"
        ref="loginFormRef20"
        :rules="loginFormRules"
      >
        <el-form-item label="扣款对象:">
          <div>{{ name }}</div>
        </el-form-item>
        <el-form-item label="扣款类型：" prop="style">
          <el-select v-model="form20.style" placeholder="请选择">
            <el-option label="授权" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="this.form20.style == 2"
          label="产品类型："
          prop="package_type"
        >
          <el-select
            v-model="form20.package_type"
            placeholder="请选择"
            @change="setMeal"
          >
            <el-option label="呼叫中心" :value="7"></el-option>
            <!-- <el-option-group label="通信产品">
              <el-option label="防骚扰" :value="1"></el-option>
              <el-option label="语音" :value="2"></el-option>
              <el-option label="文字短信" :value="3"></el-option>
              <el-option label="视频短信" :value="4"></el-option>
            </el-option-group>
            <el-option-group label="Saas产品">
              <el-option label="呼叫中心" :value="7"></el-option>
            </el-option-group> -->
          </el-select>
        </el-form-item>
        <el-form-item
          v-if="this.form20.style == 2"
          label="套餐："
          prop="package_id"
        >
          <el-select
            v-model="form20.package_id"
            placeholder="请选择"
            @change="SysAction"
          >
            <el-option
              v-for="(item, index) in this.packageList"
              :key="index"
              :label="item.package_name"
              :value="item.package_id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="this.form20.style == 2" label="余数：">
          <div>{{ this.count }}</div>
        </el-form-item>
        <el-form-item
          v-if="this.form20.style == 2"
          label="扣款个数："
          prop="charge"
          :rules="[{ required: true, validator: minRules2, trigger: 'blur' }]"
        >
          <el-input
            v-model="form20.charge"
            autocomplete="off"
            onkeyup="this.value=this.value.replace(/\D|^0/g,'')"
          ></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input v-model="form20.remark" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogTableVisiblekou = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="addRechargekou('loginFormRef20')"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <!-- 扣款 -->
  </div>
</template>

<script>
import { postData, getData } from "@/api/index";
export default {
  props: {
    msg: Object,
  },
  data() {
    return {
      package: {
        black_num: [],
        call_num: [],
        sms_num: [],
        video_sms_num: [],
        other_num: [],
      },
      packageList: [],
      count: 0,
      dialogTableVisible: false,
      dialogTableVisiblekou: false,
      formLabelWidth: "100px",
      name: "",
      form2: {
        id: "",
        style: 2,
        package_type: "",
        package_id: "",
        charge: "",
        remark: "",
      },
      form20: {
        id: "",
        style: 2,
        package_id: "",
        package_type: "",
        charge: "",
        remark: "",
      },
      loginFormRules: {
        style: [{ required: true, message: "请选择", trigger: "change" }],
        package_type: [
          { required: true, message: "请选择产品类型", trigger: "change" },
        ],
        package_id: [
          { required: true, message: "请选择套餐", trigger: "change" },
        ],
      },
    };
  },
  created() {},
  mounted() {},
  methods: {
    minRules(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入金额"));
      } else if (value < 1) {
        callback(new Error("金额不得小于1元 "));
      } else {
        callback();
      }
    },
    minRules2(rule, value, callback) {
      if (!value) {
        callback(new Error("请输入个数"));
      } else if (value < 1) {
        callback(new Error("个数不得小于1个 "));
      } else {
        callback();
      }
    },
    sysPackAgeList() {
      this.package = {
        black_num: [],
        call_num: [],
        sms_num: [],
        video_sms_num: [],
        other_num: [],
      };
      postData("company/SysPackAgeListAction").then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        let arr = Object.values(res.data);
        arr.filter((v) => {
          let arr2 = Object.values(v);
          if (this.dialogTableVisible) {
            arr2.filter((i) => {
              if (i.number !== 0) {
                if (i.package_type == 2) {
                  this.package.black_num.push(i);
                } else if (i.package_type == 1) {
                  this.package.call_num.push(i);
                } else if (i.package_type == 3) {
                  this.package.sms_num.push(i);
                } else if (i.package_type == 4) {
                  this.package.video_sms_num.push(i);
                } else if (i.package_type == 5) {
                  this.package.other_num.push(i);
                }
              } else {
                return;
              }
            });
          } else if (this.dialogTableVisiblekou) {
            arr2.filter((i) => {
              if (i.package_type == 2) {
                this.package.black_num.push(i);
              } else if (i.package_type == 1) {
                this.package.call_num.push(i);
              } else if (i.package_type == 3) {
                this.package.sms_num.push(i);
              } else if (i.package_type == 4) {
                this.package.video_sms_num.push(i);
              } else if (i.package_type == 5) {
                this.package.other_num.push(i);
              }
            });
          }
        });
      });
    },
    setMeal(value) {
      this.form2.package_id = "";
      this.form20.package_id = "";
      this.packageList = [];
      if (value == 1) {
        this.packageList = this.package.black_num;
      } else if (value == 2) {
        this.packageList = this.package.call_num;
      } else if (value == 3) {
        this.packageList = this.package.sms_num;
      } else if (value == 4) {
        this.packageList = this.package.video_sms_num;
      } else if (value == 7) {
        this.packageList = this.package.other_num;
      }
    },
    // 获取余数
    SysAction(value) {
      let admin_id = "";
      let package_type = "";
      if (this.dialogTableVisible) {
        admin_id = this.form2.id;
        package_type = this.form2.package_type;
      } else if (this.dialogTableVisiblekou) {
        admin_id = this.form20.id;
        package_type = this.form20.package_type;
      }
      postData("agent/SysAction", {
        admin_id: admin_id,
        package_type: package_type,
        package_id: value,
      }).then((res) => {
        if (res.code !== 200) return this.$message.error(res.msg);
        this.count = res.data;
      });
    },
    // 充值
    addRecharge(loginFormRef) {
      this.$refs[loginFormRef].validate((valid) => {
        if (valid) {
          this.$confirm("确定充值, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              postData("company/chargeThreeAction", this.form2).then((res) => {
                if (res.code !== 200) {
                  this.$message.error(res.msg);
                  return true;
                }
                // console.log(res);
                this.$message.success("充值成功");
                this.form2.charge = "";
                this.form2.remark = "";
                this.form2.package_type = "";
                this.form2.package_id = "";
                this.$parent.getMainData();
                this.dialogTableVisible = false;
                this.count = 0;
                this.$refs[loginFormRef].resetFields();
              });
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
              this.form2.charge = "";
              this.form2.remark = "";
              this.form2.package_type = "";
              this.form2.package_id = "";
            });
        } else {
          this.$message.success("验证失败");
          return false;
        }
      });
    },
    // 扣款
    addRechargekou(loginFormRef) {
      this.$refs[loginFormRef].validate((valid) => {
        if (valid) {
          this.$confirm("确定扣款, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              postData("company/DeductionAgentAction", this.form20).then(
                (res) => {
                  if (res.code !== 200) {
                    this.$message.error(res.msg);
                    return true;
                  }
                  // console.log(res);
                  this.$message.success("扣款成功");
                  this.form20.charge = "";
                  this.form20.remark = "";
                  this.form20.package_type = "";
                  this.form20.package_id = "";
                  this.$parent.getMainData();
                  this.dialogTableVisiblekou = false;
                  this.count = 0;
                  this.$refs[loginFormRef].resetFields();
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消",
              });
              this.form20.charge = "";
              this.form20.remark = "";
              this.form20.package_type = "";
              this.form20.package_id = "";
            });
        } else {
          this.$message.success("验证失败");
          return false;
        }
      });
    },
    guanbi(loginFormRef) {
      // console.log(loginFormRef);/
      this.$refs[loginFormRef].resetFields();
    },
  },
  watch: {
    dialogTableVisible() {
      if (this.dialogTableVisible) {
        this.sysPackAgeList();
      }
    },
    dialogTableVisiblekou() {
      if (this.dialogTableVisiblekou) {
        this.sysPackAgeList();
      }
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .el-form-item__content {
  margin-right: 4%;
}
</style>
<style lang="less" src="@/assets/css/dialogbox.less" scoped></style>
